type QueryParamValue = string | string[] | undefined | null;

export const buildQueryParams = (
  params: Record<string, QueryParamValue>,
): string => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    const values = Array.isArray(value) ? value : [value];

    values.forEach((item) => {
      const normalized = item?.toString().trim();

      if (normalized) {
        searchParams.append(key, normalized);
      }
    });
  });

  return searchParams.toString();
};
